// Timed-caption helpers: the panel renders captions itself (styled overlay +
// transcript) rather than relying on the browser's track rendering, so the
// message lands identically on every device.
const stamp = (s) => {
  const [hms, ms = "0"] = s.trim().replace(",", ".").split(".");
  const parts = hms.split(":").map(Number);
  while (parts.length < 3) parts.unshift(0);
  const [h, m, sec] = parts;
  return h * 3600 + m * 60 + sec + Number(`0.${ms.replace(/\D/g, "") || 0}`);
};

export const parseCaptions = (text) => {
  if (!text) return [];
  const cues = [];
  const blocks = text.replace(/\r/g, "").replace(/^WEBVTT.*?\n\n/s, "").split(/\n{2,}/);
  blocks.forEach((block) => {
    const lines = block.split("\n").filter(Boolean);
    const timeLine = lines.find((l) => l.includes("-->"));
    if (!timeLine) return;
    const [from, to] = timeLine.split("-->");
    const body = lines.slice(lines.indexOf(timeLine) + 1).join(" ").trim();
    if (!body) return;
    cues.push({ start: stamp(from), end: stamp(to), text: body });
  });
  return cues.sort((a, b) => a.start - b.start);
};

export const cueAt = (cues, t) => cues.find((c) => t >= c.start && t <= c.end)?.text || "";

// Plain reading copy for the transcript panel (also what Google indexes).
export const captionsToTranscript = (text) =>
  parseCaptions(text).map((c) => c.text).join(" ");

// SRT is what most caption tools export; WebVTT is what browsers expect.
export const toVtt = (raw) => {
  const text = (raw || "").replace(/\r/g, "").trim();
  if (!text) return "";
  if (/^WEBVTT/.test(text)) return text;
  const body = text.replace(/(\d{2}:\d{2}:\d{2}),(\d{3})/g, "$1.$2");
  return `WEBVTT\n\n${body}\n`;
};
